


























import { Component, Prop, Vue, Watch } from 'vue-property-decorator';
@Component({
  name: 'lb-switch',
})
export default class extends Vue {
  @Prop() private value!: any;
  @Prop() private activeText!: string;
  @Prop() private inactiveText!: string;
  @Prop({ type: Boolean, default: false }) private disabled!: boolean;

  private switchChecked = this.value;

  private handleSwitchClick(e: any) {
    if (!this.disabled) {
      this.switchChecked = !this.switchChecked;
    } else {
      e.preventDefault();
    }
  }

  @Watch('value')
  private onValueChange(val: any) {
    this.switchChecked = val;
  }

  @Watch('switchChecked')
  private onSwitchCheckedChange(val: any) {
    this.$emit('input', val);
    this.$emit('change', val);
  }
}
